import { useEffect } from "react";

/**
 * The marketing blog is server-rendered by the API (packages/blog-engine) and
 * served at weconsultrx.com/blog* by an edge Cloudflare Worker (wcrx-blog-proxy).
 * A direct/external load of /blog* is handled entirely at the edge and never
 * boots this SPA. This gateway only runs when an in-app <Link to="/blog"> does a
 * client-side navigation that the SPA router would otherwise capture — so we
 * force a full document navigation, which the Worker serves from the API.
 *
 * This replaces the former static React blog (pages/Blog + pages/BlogPost +
 * src/content/blog), retired once the server-rendered blog went live.
 */
export function BlogGateway() {
  useEffect(() => {
    window.location.href =
      window.location.pathname + window.location.search + window.location.hash;
  }, []);
  return null;
}
